module.exports = __webpack_public_path__ + "static/services-corner-front_pt.bf056473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services-corner-front_pt.png
// module id = 439
// module chunks = 35783957827783